import { useState } from "react";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";

interface HistoryItem {
    date: string; // YYYY-MM-DD
    code: string;
    content: string;
    order: string;
}

const MOCK_DATA: HistoryItem[] = [
    {
        date: "2026-02-01",
        code: "CHUYENKHOAN2602",
        content: "Giảm 50.000đ cho đơn từ 2.500.000đ",
        order: "DH00123",
    },
    {
        date: "2026-02-10",
        code: "GIAM5PT",
        content: "Giảm 5% thanh toán chuyển khoản",
        order: "DH00456",
    },
];

export default function VoucherHistory() {
    const [fromDate, setFromDate] = useState<Dayjs | null>(null);
    const [toDate, setToDate] = useState<Dayjs | null>(null);
    const [data, setData] = useState<HistoryItem[]>(MOCK_DATA);

    const handleSearch = () => {
        if (!fromDate && !toDate) {
            // không chọn ngày → show tất cả
            setData(MOCK_DATA);
            return;
        }

        const filtered = MOCK_DATA.filter((item) => {
            const d = dayjs(item.date);
            if (fromDate && d.isBefore(fromDate, "day")) return false;
            if (toDate && d.isAfter(toDate, "day")) return false;
            return true;
        });

        setData(filtered);
    };

    return (
        <div className="MuiGrid-root styles_historyVoucherCtn__g_2M3 MuiGrid-container" style={{ backgroundColor: "rgb(244, 247, 252)" }}>
            {/* TITLE */}
            <div className="MuiGrid-root styles_title___1eh1 MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
                <p className="MuiTypography-root MuiTypography-body1">
                    Lịch sử dùng mã giảm giá
                </p>
            </div>
            <div className="filter-history-voucher">
                {/* FROM DATE */}
                <div
                    className="one-item"
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                    <span style={{ fontFamily: "ggsr", width: "26px" }}>Từ</span>
                    <DatePicker
                        format="DD/MM/YYYY"
                        placeholder="ngày/tháng/năm"
                        value={fromDate}
                        onChange={(d) => setFromDate(d)}
                        style={{ width: "100%", height: "38px" }}
                    />
                </div>

                {/* TO DATE */}
                <div
                    className="one-item"
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                    <span style={{ fontFamily: "ggsr", width: "26px" }}>Đến</span>
                    <DatePicker
                        format="DD/MM/YYYY"
                        placeholder="ngày/tháng/năm"
                        value={toDate}
                        onChange={(d) => setToDate(d)}
                        style={{ width: "100%", height: "38px" }}
                    />
                </div>

                {/* SEARCH BUTTON */}
                <div
                    className="one-item"
                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                    <button
                        className="MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 iQEreR styles_search__0DsBP"
                        type="button"
                        onClick={handleSearch}
                    >
                        <span className="MuiButton-label">Tìm kiếm</span>
                        <span className="MuiTouchRipple-root" />
                    </button>
                </div>
            </div>
            {/* TABLE */}
            <div className="MuiGrid-root styles_wrapTable__psp3y MuiGrid-container">
                <div className="MuiPaper-root styles_root__6UJMC MuiPaper-elevation1 MuiPaper-rounded">
                    <div className="MuiTableContainer-root styles_headTable__zFdJl">
                        <table
                            className="MuiTable-root MuiTable-stickyHeader"
                            aria-label="sticky table"
                        >
                            <thead className="MuiTableHead-root">
                                <tr className="MuiTableRow-root MuiTableRow-head">
                                    <th className="MuiTableCell-root styles_tablle_origin__fWoHy MuiTableCell-head MuiTableCell-alignLeft MuiTableCell-stickyHeader">
                                        Ngày sử dụng
                                    </th>
                                    <th className="MuiTableCell-root styles_tablle_origin__fWoHy MuiTableCell-head MuiTableCell-alignLeft MuiTableCell-stickyHeader">
                                        Mã code giảm giá
                                    </th>
                                    <th className="MuiTableCell-root styles_tablle_origin__fWoHy MuiTableCell-head MuiTableCell-alignLeft MuiTableCell-stickyHeader">
                                        Nội dung
                                    </th>
                                    <th className="MuiTableCell-root styles_tablle_origin__fWoHy MuiTableCell-head MuiTableCell-alignRight MuiTableCell-stickyHeader">
                                        Đơn hàng liên quan
                                    </th>
                                </tr>
                            </thead>

                            <tbody className="MuiTableBody-root">
                                {data.length === 0 ? (
                                    <tr className="MuiTableRow-root MuiTableRow-hover">
                                        <th
                                            className="MuiTableCell-root MuiTableCell-body MuiTableCell-alignCenter"
                                            colSpan={5}
                                            style={{ display: "table-cell" }}
                                        >
                                            <p
                                                className="MuiTypography-root MuiTypography-body1"
                                                style={{ fontFamily: "ggsm" }}
                                            >
                                                Bạn chưa dùng mã nào
                                            </p>
                                        </th>
                                    </tr>
                                ) : (
                                    data.map((item, idx) => (
                                        <tr className="MuiTableRow-root MuiTableRow-hover" key={idx}>
                                            <td className="MuiTableCell-root MuiTableCell-body">
                                                {dayjs(item.date).format("DD/MM/YYYY")}
                                            </td>
                                            <td className="MuiTableCell-root MuiTableCell-body">
                                                {item.code}
                                            </td>
                                            <td className="MuiTableCell-root MuiTableCell-body">
                                                {item.content}
                                            </td>
                                            <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-alignRight">
                                                {item.order}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="MuiGrid-root styles_wrapViewMore__eKNS_ MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-center" />
        </div>
    );
}
